import API from '../api-service';

const baseUri = 'list';

export default {
  getLists() {
    return API.get(`${baseUri}`);
  },
  createList(body) {
    return API.post(`${baseUri}`, body);
  },
  updateList(syncguid, body) {
    return API.patch(`${baseUri}/${syncguid}`, body);
  },
  getListCourses(syncguid) {
    return API.get(`${baseUri}/${syncguid}/courses`);
  },
  createListCourse(syncguid, body) {
    return API.post(`${baseUri}/${syncguid}/courses`, body);
  },
  removeListCourses(syncguid, body) {
    return API.delete(`${baseUri}/${syncguid}/courses`, body);
  },
};
